<template>
    <div>
        <div class="d-flex flex-column align-items-center text-center bg-white pt-5 pb-4 pb-lg-4 px-3 mb-0 mb-lg-0">
            <img alt="" :src="`/img/hcpay/error/payment-option-unavailable.svg`" class="errorMessageIcon img-responsive">
            <span class="font-md font-weight-bold my-3">
                    Thank you for your interest in <br />Home Credit!
                </span>
                <span class="font-sm text-secondary">
                    Download the Home Credit app and sign up for an account to enjoy our exciting deals, offers, and more! 
                    <br />
                    <br />
                    Already have an account with us? Make sure your payment option is active and has enough balance, then retry your purchase.
                </span>
        </div>

        <div class="mt-2 d-flex flex-column align-items-center bg-white p-4">
            <download-opg-v3 
                class="px-4" 
                google-play-id="loginGooglePlayBtn" 
                qr-code-id="loginQRCode" 
                description="Get the latest version of the My Home Credit app on Google Play or scan the QR code below."
            />
        </div>

        <div class="d-flex flex-column rounded align-items-center py-4 bg-white my-2">
            <embed-video></embed-video>
            <span class="font-sm font-weight-medium text-secondary px-3 text-center pt-4">Manage payments, avail of loans, shop in installments, receive promos and many more with Home Credit app!</span>
            <br>
            <span class="font-sm font-weight-medium text-secondary px-3 text-center">To learn more about HCPay, <a @click="websiteDirect" class="link-hc-site text-green font-weight-bold" href="https://homecredit.ph/hcpay/">visit our website</a></span>
            <back-to-store @click="backButton" v-if="!this.$root.$data.transaction.partnerId" class="pt-5">Back to Store</back-to-store>
            <back-to-store @click="backButton" v-else class="pt-5">Back to Merchant</back-to-store>
        </div>
    </div>
</template>
<script>
import { ERROR } from '../mixins/error_codes.js';

export default {
    data() {
        return {
            error: this.$root.error,
            downloadEventName: 'err_no_hc_acct_install_hc_app',
        }
    },
    created(){
        let g4params = {
            'userId': this.$root.$data.account.userId,
            'cuid': this.$root.$data.account.cuid,
            'ip': this.$root.transaction.ipAddress,
            'user_agent': this.$root.$data.analyticsData.userAgent,
            'phone': this.$root.$data.analyticsData.phone,
            'operating_system': this.$root.$data.analyticsData.operatingSystem.name+"V"+this.$root.$data.analyticsData.operatingSystem.version,
            'browser': this.$root.$data.analyticsData.browser.name+"V"+this.$root.$data.analyticsData.browser.version,
            'transaction_type': this.$root.$data.transaction.referenceNumber.substring(0, 2),
            'transaction_reference': this.$root.$data.transaction.referenceNumber,
        }       
        this.$root.triggerG4Event('err_no_hc_acct',g4params);
        this.$root.$data.previousView = 'not-available';
    },
    methods: {
        openSite(){
            window.location.href = "https://homecredit.ph/credit-card/";
        },
        websiteDirect() {
            let g4params = {
                'userId': this.$root.$data.account.userId,
                'cuid': this.$root.$data.account.cuid,
                'ip': this.$root.transaction.ipAddress,
                'user_agent': this.$root.$data.analyticsData.userAgent,
                'phone': this.$root.$data.analyticsData.phone,
                'operating_system': this.$root.$data.analyticsData.operatingSystem.name+"V"+this.$root.$data.analyticsData.operatingSystem.version,
                'browser': this.$root.$data.analyticsData.browser.name+"V"+this.$root.$data.analyticsData.browser.version,
                'transaction_type': this.$root.$data.transaction.referenceNumber.substring(0, 2),
                'transaction_reference': this.$root.$data.transaction.referenceNumber,
            }       
            this.$root.triggerG4Event('err_no_hc_acct_click_visit_website',g4params)
        },
        backButton() {
            let g4params = {
                'userId': this.$root.$data.account.userId,
                'cuid': this.$root.$data.account.cuid,
                'ip': this.$root.transaction.ipAddress,
                'user_agent': this.$root.$data.analyticsData.userAgent,
                'phone': this.$root.$data.analyticsData.phone,
                'operating_system': this.$root.$data.analyticsData.operatingSystem.name+"V"+this.$root.$data.analyticsData.operatingSystem.version,
                'browser': this.$root.$data.analyticsData.browser.name+"V"+this.$root.$data.analyticsData.browser.version,
                'transaction_type': this.$root.$data.transaction.referenceNumber.substring(0, 2),
                'transaction_reference': this.$root.$data.transaction.referenceNumber,
            }       
            this.$root.triggerG4Event('err_no_hc_acct_click_back_to_store',g4params)
        }
    }
}
</script>
<style scoped>
    .errorMessageIcon {
        height: auto;
        width: 9rem;
    }
    .paymentOptionCard {
        height: auto;
        width: 8rem;
    }
    .text-tertiary {
        color: #8C8C8C !important;
        margin-top: 1em;
    }
    .creditcardBg {
        background-color: #2196F3;
    }
    .walletpayBg {
        background-color: #009688;
    }
    .link-hc-site:hover{
        color: #49B672;
    }
</style>